/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In ${i?.slot} — tap to move here`)
};

const es_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En ${i?.slot} — toca para mover aquí`)
};

const de_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In ${i?.slot} — tippe zum Verschieben`)
};

const nl_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In ${i?.slot} — tik om te verplaatsen`)
};

const fr_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dans ${i?.slot} — touchez pour déplacer ici`)
};

const it_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In ${i?.slot} — tocca per spostare qui`)
};

const pt_br2_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Em ${i?.slot} — toque para mover aqui`)
};

const pt_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Em ${i?.slot} — toque para mover aqui`)
};

const ja_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.slot}に — タップして移動`)
};

const zh_f1_modal_in_slot = /** @type {(inputs: { slot: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在${i?.slot} — 点击移至此处`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ slot: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_modal_in_slot = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_modal_in_slot(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_modal_in_slot", locale)
	if (locale === "en") return en_f1_modal_in_slot(inputs)
	if (locale === "es") return es_f1_modal_in_slot(inputs)
	if (locale === "de") return de_f1_modal_in_slot(inputs)
	if (locale === "nl") return nl_f1_modal_in_slot(inputs)
	if (locale === "fr") return fr_f1_modal_in_slot(inputs)
	if (locale === "it") return it_f1_modal_in_slot(inputs)
	if (locale === "pt-BR") return pt_br2_f1_modal_in_slot(inputs)
	if (locale === "pt") return pt_f1_modal_in_slot(inputs)
	if (locale === "ja") return ja_f1_modal_in_slot(inputs)
	return zh_f1_modal_in_slot(inputs)
};